import React from 'react';
import { Checkbox, Grid } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { shiftDifferentialModStyles } from './ShiftDifferentialMod.style';

const WeekdayComponent = React.memo(function WeekdayComponent(params: any) {
  const { classes } = shiftDifferentialModStyles({ isModEdit: false });
  return (
    <Grid container direction="row" justifyContent={params.colDef.headerAlign} wrap="nowrap">
      <Checkbox checked={params.value} className={classes.switchLightBlue} disabled={!params.isEditable} />
    </Grid>
  );
});

export const ShiftDiffWeekday = (params: GridCellParams) => {
  return <WeekdayComponent {...params} />;
};
